import { Box } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';
import { StoreProvider } from '../../context';
import { NavSideBar } from '../User/NavSideBar/NavSideBar';

export const UserLayout = () => {
  return (
    <StoreProvider>
      <NavSideBar />

      <Box background='brand.white' minH='100%' h='100%' ml={{ base: 0, lg: '335px' }}>
        <Outlet />
      </Box>
    </StoreProvider>
  );
};
